import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { commonThemeBackgroundClass } from '../../core/utilities/color';

@Component({
    selector: 'app-qrcode',
    templateUrl: './qrcode.component.html',
    styleUrls: ['./qrcode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class QrcodeComponent {

  @Input() public data?: string;
  @Input() public size: 'regular' | 'huge' = 'regular';


  @HostBinding('class')
  protected get classes(): string {
    return [
      'flex-center',
      commonThemeBackgroundClass('background'),
      this.size
    ].join(' ');
  }

  protected get qrWidth(): number {
    return this.size === 'huge' ? 212 : 98;
  }

}
